import { createFileRoute } from "@tanstack/react-router";
import BrandPage from "@/pages/BrandPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-forest-river-rv/")({
  head: () => pageHead({ title: 'Forest River RVs', description: 'Shop Forest River RVs at Rex & Sons RVs in Castle Hayne, NC.', path: '/product-forest-river-rv' }),
  component: BrandPage,
});